import script from "./LbrxTargetQueuesDrawer.vue?vue&type=script&setup=true&lang=ts"
export * from "./LbrxTargetQueuesDrawer.vue?vue&type=script&setup=true&lang=ts"

import "./LbrxTargetQueuesDrawer.vue?vue&type=style&index=0&id=48cf4482&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48cf4482"]])

export default __exports__